import { GO_BOARD_MOKA_KOMI } from "@/constants";
import { getAdjacentGoBoardCoordinates } from "@/utils/get-adjacent-go-board-coordinates";
import { getGoBoardCoordinateKey } from "@/utils/get-go-board-coordinate-key";

const getMokaAreaAnalysis = (
  gameState: MokaGameState,
  options: MokaAreaAnalysisOptions = {},
): MokaAreaAnalysis => {
  const boardSize = gameState.board.length;
  const visitedCoordinateKeys = new Set<number>();
  const blackTerritoryCoordinates: GoBoardCoordinate[] = [];
  const whiteTerritoryCoordinates: GoBoardCoordinate[] = [];
  let blackStoneCount = 0;
  let neutralPointCount = 0;
  let whiteStoneCount = 0;

  for (const boardRow of gameState.board) {
    for (const stone of boardRow) {
      if (stone?.color === "black") {
        blackStoneCount += 1;
      } else if (stone?.color === "white") {
        whiteStoneCount += 1;
      }
    }
  }

  const canAssignTerritory =
    !options.isTerritoryConservative || (blackStoneCount > 0 && whiteStoneCount > 0);

  for (let row = 0; row < boardSize; row += 1) {
    for (let column = 0; column < boardSize; column += 1) {
      const startingCoordinate = { column, row };
      const startingCoordinateKey = getGoBoardCoordinateKey(startingCoordinate, boardSize);

      if (gameState.board[row][column] || visitedCoordinateKeys.has(startingCoordinateKey)) {
        continue;
      }

      const pendingCoordinates = [startingCoordinate];
      const territoryCoordinates: GoBoardCoordinate[] = [];
      const borderingColors = new Set<"black" | "white">();

      while (pendingCoordinates.length > 0) {
        const coordinate = pendingCoordinates.pop();

        if (!coordinate) {
          continue;
        }

        const coordinateKey = getGoBoardCoordinateKey(coordinate, boardSize);

        if (visitedCoordinateKeys.has(coordinateKey)) {
          continue;
        }

        visitedCoordinateKeys.add(coordinateKey);
        territoryCoordinates.push(coordinate);

        for (const adjacentCoordinate of getAdjacentGoBoardCoordinates(coordinate, boardSize)) {
          const adjacentStone = gameState.board[adjacentCoordinate.row][adjacentCoordinate.column];

          if (adjacentStone) {
            borderingColors.add(adjacentStone.color);
          } else {
            pendingCoordinates.push(adjacentCoordinate);
          }
        }
      }

      if (canAssignTerritory && borderingColors.size === 1 && borderingColors.has("black")) {
        blackTerritoryCoordinates.push(...territoryCoordinates);
      } else if (canAssignTerritory && borderingColors.size === 1 && borderingColors.has("white")) {
        whiteTerritoryCoordinates.push(...territoryCoordinates);
      } else {
        neutralPointCount += territoryCoordinates.length;
      }
    }
  }

  return {
    blackStoneCount,
    blackTerritoryCoordinates,
    neutralPointCount,
    score:
      blackStoneCount +
      blackTerritoryCoordinates.length -
      whiteStoneCount -
      whiteTerritoryCoordinates.length -
      GO_BOARD_MOKA_KOMI,
    whiteStoneCount,
    whiteTerritoryCoordinates,
  };
};

export { getMokaAreaAnalysis };
